export { default } from "./Panel";




// WEBPACK FOOTER //
// ./src/components/Panel/index.js